<figure>
    <img src="{{assetsConst.authRight}}" alt="show icon">
</figure>
<h2>Your Loved Academic Companion</h2>
<p>Empowering learners with personalized solutions</p>